import logoHeader from "../../assets/images/logo-header.png"
import "./Headerbar.css"
import { Row, Col, Avatar, Button, Menu, Modal } from "antd"
import { useState } from "react";
import { FaRegUser } from 'react-icons/fa';
import { IoLogOutOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { HEADERBAR_CONSTANT } from "../../constant/header.constant";
import { useDispatch, useSelector } from 'react-redux';
import { loginReducerAction } from "../../store/loginReducer";
import loginService from "../../service/loginService";

const Headerbar = () => {
  const { SubMenu } = Menu;
  const [hoverActive, setHoverActive] = useState(false);
  const navigate = useNavigate();
  const [selectMenuKey, setSelectMenuKey] = useState("");
  const dispatch = useDispatch();
  const userFullName = useSelector((state) => state.loginData.firstname + " " + state.loginData.lastname);
  const token = useSelector((state) => state.loginData.token);

  const handleAvatarClick = () => {
    setHoverActive(!hoverActive);
  }

  const handleLogout = () => {
    setSelectMenuKey("logout-button")
    Modal.confirm({
      title: HEADERBAR_CONSTANT.MODAL_TITLE_LOGOUT,
      content: HEADERBAR_CONSTANT.MODAL_CONTENT_LOGOUT,
      okText: HEADERBAR_CONSTANT.MODAL_OK_BUTTON_LOGOUT,
      cancelText: HEADERBAR_CONSTANT.MODAL_CANCEL_BUTTON_LOGOUT,
      centered: true,
      icon: null,
      onOk() {
        dispatch(loginReducerAction.onLogout());
        loginService.logout(token);
        navigate("/");
      },
      onCancel() {
        setSelectMenuKey("");
      }
    });
  }

  const buttonUserProfile = () => {
    return (
      <Button
        shape="round"
        onClick={() => handleAvatarClick()}
        className={hoverActive ? "button-avatar-style active" : "button-avatar-style"}
      >
        <Avatar
          className="avatar-transparent-background"
          icon={<FaRegUser style={{ color: "dodgerblue" }} />} />
        <span className="menu-text-style"> {userFullName} </span>
      </Button>
    )
  }

  return (
    <Row justify="space-between">

      <Col>
        <img className="image-style" src={logoHeader} alt="logo-nextoken-header" />
      </Col>

      <Col>
        <Menu mode="inline" className="user-profile-menu-style" onOpenChange={() => handleAvatarClick()} selectedKeys={[selectMenuKey]}>
          <SubMenu key="user-profile-avatar" title={buttonUserProfile()}>
            <Menu.Item key="logout-button" className="menu-item-style">
              <Button
                shape="round"
                className="button-avatar-style"
                onClick={() => handleLogout()}
              >
                <Avatar
                  className="avatar-transparent-background"
                  icon={<IoLogOutOutline style={{ color: "dodgerblue" }} />} />
                <span className="menu-text-style"> Logout </span>
              </Button>
            </Menu.Item>
          </SubMenu>
        </Menu>

      </Col>

    </Row>
  )
}

export default Headerbar;